<aus-outdated-browser
  *ngIf="ps.isBrowser()"
  (continue)="onContinue()"
></aus-outdated-browser>
